import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3944";

export interface TeamMember {
  id: string;
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  phone?: string;
  niveau: number;
  role: string;
  status: string;
  user_status: string;
  last_login?: string;
  created_at: string;
  institution_code?: string;
}

export interface CreateTeamMemberRequest {
  firstname: string;
  lastname: string;
  username: string;
  email: string;
  phone?: string;
  password: string;
  merchant_code: string;
  niveau: number;
}

export interface UpdateTeamMemberRequest {
  firstname?: string;
  lastname?: string;
  email?: string;
  phone?: string;
  niveau?: number;
  status?: string;
}

export const teamService = {
  // Get all team members
  async getTeamMembers(): Promise<TeamMember[]> {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/team/members`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

    // Reset password for a user
  async resetUserPassword(userId: string, newPassword: string): Promise<void> {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${API_URL}/team/members/${userId}/reset-password`,
      { new_password: newPassword },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  },

  // Activate/Deactivate user
  async toggleUserStatus(userId: string, status: string): Promise<void> {
    const token = localStorage.getItem("token");
    const response = await axios.patch(
      `${API_URL}/team/members/${userId}/status`,
      { status },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  },

  // Generate random password
  generateRandomPassword(): string {
    const length = 12;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
  },

  // Add new member
  async createTeamMember(memberData: CreateTeamMemberRequest): Promise<TeamMember> {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API_URL}/team/members`, memberData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Update member
  async updateTeamMember(id: string, memberData: UpdateTeamMemberRequest): Promise<TeamMember> {
    const token = localStorage.getItem("token");
    const response = await axios.put(`${API_URL}/team/members/${id}`, memberData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Delete member
  async deleteTeamMember(id: string): Promise<void> {
    const token = localStorage.getItem("token");
    await axios.delete(`${API_URL}/team/members/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  // Get team statistics
  async getTeamStats(): Promise<any> {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/team/stats`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }
};